import React from "react";
import AdminHeader from "../../../components/admin/AdminHeader";
import { AdminFooter } from "../../../components/admin/AdminFooter";
import AdminPrivacyPolicy from "../../../views/admin/cms/AdminPrivacyPolicy";

const AdminPrivacyPolicyPage = () => {
  window.scrollTo(0, 0);

  return (
    <div>
      <AdminHeader />
        <AdminPrivacyPolicy />
      <AdminFooter />
    </div>
  );
};

export default AdminPrivacyPolicyPage;
